// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#126aa2"};